module.exports = Em.Handlebars.compile("<div {{bind-attr class=\":loading-screen appName\"}}>\n    {{application-error error=model.message}}\n</div>\n");